export const columns = [
  {
    title: "Ονοματεπώνυμο",
    dataIndex: 'fullName',
    key: 'fullName',
    width: 126,
    fixed: "left",
  },
  {
    title: "Α.Φ.Μ.",
    dataIndex: 'afm',
    key: 'afm',
    width: 126,
    fixed: "left",
  },
  {
    title: "Ημ. Γέννησης",
    dataIndex: 'dateOfBirth',
    key: 'dateOfBirth',
    render: (text, record) => {
      return text;
    },
    width: 50,
    fixed: "left",
  },
  {
    title: "% Συμμετοχής",
    dataIndex: 'participationRate',
    key: 'participationRate',
    render: (text, record) => {
      return text;
    },
    width: 120,
    fixed: "center",
    align: "center"
  },
  {
    title: "Ιδιότητα",
    dataIndex: 'role',
    key: 'role',
    width: 126,
    fixed: "left",
  },
];
